module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Wood_MockedUp.277ada38.jpg";